import React, { useEffect } from 'react'
import UserSummary from './UserSummary/UserSummary'
import * as actions from '../../store/actions/index'
import { connect } from 'react-redux'

const Stats = props => {
  useEffect(() => {
    props.onFetchGames()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let userSummary = <h2>loading...</h2>
  if (!props.loading) {
    userSummary = <UserSummary gamesPlayed={props.gamesPlayed} />
  }

  return (
    <React.Fragment>
      {userSummary}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {
    gamesPlayed: state.stats.gamesPlayed,
    loading: state.stats.loading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetGamesPlayed: (gamesPlayed) => dispatch(actions.setGamesPlayed(gamesPlayed)),
    onFetchGames: () => dispatch(actions.fetchGamesInit())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Stats)